import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { v4 as uuidv4 } from 'uuid';

export interface MaxResultsListState {
  name: number;
  id: number;
  uuid: string;
}

const initialState: MaxResultsListState[] = [
  {
    name: 50,
    id: 2,
    uuid: uuidv4(),
  },
  {
    name: 100,
    id: 3,
    uuid: uuidv4(),
  },
  {
    name: 200,
    id: 4,
    uuid: uuidv4(),
  },
  {
    name: 500,
    id: 5,
    uuid: uuidv4(),
  },
];

const maxResultsListSlice = createSlice({
  name: Slices.MAX_RESULTS_LIST,
  initialState,
  reducers: {
    setMaxResultsList: (_, action) => {
      return action.payload;
    },
    clearMaxResultsList: () => {
      return initialState;
    },
  },
});

export const { setMaxResultsList, clearMaxResultsList } = maxResultsListSlice.actions;

export default maxResultsListSlice.reducer;
